export function CharterMemberIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 8h16v6c0 4-3 6-8 8-5-2-8-4-8-8z" />
      <path d="M12 10h-2c-2 0-2 2-2 4s2 4 4 4h4" />
      <path d="M36 10h2c2 0 2 2 2 4s-2 4-4 4h-4" />
      <line x1="16" y1="26" x2="32" y2="26" />
      <rect x="14" y="28" width="20" height="4" rx="1" />
      <line x1="24" y1="32" x2="24" y2="40" />
      <path d="M18 40h12" />
    </svg>
  );
}
